import AppHeader from "@/components/AppHeader";

export default {
  name: "home",
  components: {
    AppHeader
  },
  created() {
    this.getExistApproval();
  },
  data() {
    return {
      isExistApproval: false
    };
  },
  methods: {
    async getExistApproval() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_EXIST_APPROVAL", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.isExistApproval = res.is_exist_approval;
    },
    authorityCheck(menu) {
      if (menu == "approval" && localStorage.user_authority == 4) {
        // 承認一覧かつ総務部でログイン
        return false;
      } else if (
        menu == "csv" &&
        (localStorage.user_authority == 2 || localStorage.user_authority == 3)
      ) {
        // 各種マスタ管理・csvダウンロードかつ役員でログイン
        return false;
      } else if (menu == "master" && localStorage.user_authority == 2) {
        return false;
      }
      return true;
    },
    goKintai() {
      this.$store.dispatch("GO_KINTAI").catch(err => {
        console.log(err);
        return;
      });
    }
  }
};
